import { createStore, applyMiddleware } from 'redux'
import reducer from './reducer'
import tokenMiddleware from './token/middleware'
import userMiddleware from './user/middleware'
import repositoriesMiddleware from './repositories/middleware'
import { authorizeToken } from './token/actions'
import branchesMiddleware from './branches/middleware'
//import filesMiddleware from './files/middleware'
import batchActionsMiddleware from './batchActions/middleware'
import { setUser } from './user/actions'

const store = createStore(
  reducer,
  applyMiddleware(
    tokenMiddleware,
    userMiddleware,
    repositoriesMiddleware,
    branchesMiddleware,
    //filesMiddleware,
    batchActionsMiddleware,
  )
)

var token = localStorage.getItem('token')
if (token && token !== 'undefined')
  store.dispatch(authorizeToken(token))
var user = localStorage.getItem('user')
if (user && user !== 'undefined'){
  try {
    user = JSON.parse(user)
  } catch (err){}
  if (user)
   store.dispatch(setUser(user))
}

global.store = store

// Listen for an auth token change and save it to local storage
;(() => {
  var lastToken = store.getState().token
  var lastUser = store.getState().user
  store.subscribe(() => {
    const state = store.getState()
    const { token, user } = state
    if (!token)
      localStorage.removeItem('token')
    else if (lastToken != token)
      localStorage.setItem('token', token)
    if (!user)
      localStorage.removeItem('user')
    else if (lastUser != user)
      localStorage.setItem('user', JSON.stringify(user))
  })
})()
export default store


// WEBPACK FOOTER //
// ./src/store/store.js